/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import { toEnglishNum, toPersianNum } from "utils/helpers";
import "./editableCell.scss";
import { EXPAND_LIST_DAILY_TYPE } from "utils/Constants";

const EditableCell = ({
    item,
    handleLogChange,
    defaultFood,
    isUpdate,
    isDisabled,
    cellId,
    rowId,
    totalCells,
    totalRows,
    cellType,
}) => {
    let currentRow = rowId;
    let currentCell = cellId;

    const foodValue = {
        b2c: defaultFood
            ? isUpdate
                ? item.qty_2 === 0
                    ? 0
                    : defaultFood.qty_2
                : item.qty === 0
                ? 0
                : defaultFood.qty
            : 0,
        b2b: item.b2b_stock,
        total:
            item.b2b_stock +
            (isUpdate
                ? item.qty_2 === 0
                    ? 0
                    : defaultFood.qty_2
                : item.qty === 0
                ? 0
                : defaultFood.qty),
    };

    let inputDefaultValue = foodValue.b2c;

    if (cellType === EXPAND_LIST_DAILY_TYPE.b2b) {
        inputDefaultValue = foodValue.b2b;
    } else if (cellType === EXPAND_LIST_DAILY_TYPE.total) {
        inputDefaultValue = foodValue.total;
    }

    const input = {
        name: item.snapp_food_id,
        defaultValue: inputDefaultValue,
    };

    useEffect(() => {
        setInputValue({
            value: input.defaultValue,
            clearValue: input.defaultValue,
            originalValue: input.defaultValue,
        });
    }, [cellType]);

    // because of using states for props that are being sent from the parent component
    // we should use useEffect for setting the states again :(
    useEffect(() => {
        setInputValue({
            value: input.defaultValue,
            clearValue: input.defaultValue,
            originalValue: input.defaultValue,
        });
    }, [item]);

    const [inputValue, setInputValue] = useState({
        value: input.defaultValue,
        clearValue: input.defaultValue,
        originalValue: input.defaultValue,
    });

    useEffect(() => {
        setInputValue({
            value: input?.defaultValue,
            clearValue: input?.defaultValue,
            originalValue: input?.defaultValue,
        });
    }, [defaultFood]);

    // useEffect(() => {
    //     if (rowId === 0 && cellId === 1 && inputValue.value !== "") {
    //         setInputValue({ ...inputValue, value: "" });
    //         changeCurrentCell("focus", 0, 1);
    //     }
    // }, []);

    const handleInputChange = (name, value) => {
        handleLogChange(
            name,
            toEnglishNum(value) && toEnglishNum(value).length > 0
                ? toEnglishNum(value)
                : value
        );
        if (value === "") {
            setInputValue({
                ...inputValue,
                value: "",
                clearValue: inputValue.originalValue,
            });
        } else {
            setInputValue({
                ...inputValue,
                value,
                clearValue: value,
            });
        }
    };

    const changeCurrentCell = (arrowDirection, rowId, cellId) => {
        let rowIndex;
        let cellIndex;
        if (arrowDirection === "focus") {
            rowIndex = rowId;
            cellIndex = cellId;
            setInputValue({ ...inputValue, value: "" });
        } else if (arrowDirection === "blur") {
            setInputValue({ ...inputValue, value: inputValue.clearValue });
        } else {
            rowIndex = currentRow;
            cellIndex = currentCell;
        }

        switch (arrowDirection) {
            case "Enter":
                if (inputValue.value === "") {
                    setInputValue({
                        ...inputValue,
                        value: inputValue.clearValue,
                    });
                } else {
                    while (rowIndex < totalRows - 1) {
                        rowIndex = rowIndex + 1;
                        if (
                            document.getElementById(
                                `${rowIndex}-${currentCell}`
                            ) !== null
                        ) {
                            document
                                .getElementById(`${rowIndex}-${currentCell}`)
                                .focus();
                            break;
                        }
                    }
                }

                break;
            case "ArrowUp":
                if (inputValue.value === "") {
                    setInputValue({
                        ...inputValue,
                        value: inputValue.clearValue,
                    });
                }
                while (rowIndex > 0) {
                    rowIndex = rowIndex - 1;
                    if (
                        document.getElementById(
                            `${rowIndex}-${currentCell}`
                        ) !== null
                    ) {
                        document
                            .getElementById(`${rowIndex}-${currentCell}`)
                            .focus();
                        break;
                    }
                }
                break;
            case "ArrowDown":
                if (inputValue.value === "") {
                    setInputValue({
                        ...inputValue,
                        value: inputValue.clearValue,
                    });
                }
                while (rowIndex < totalRows - 1) {
                    rowIndex = rowIndex + 1;
                    if (
                        document.getElementById(
                            `${rowIndex}-${currentCell}`
                        ) !== null
                    ) {
                        document
                            .getElementById(`${rowIndex}-${currentCell}`)
                            .focus();
                        break;
                    }
                }
                break;
            case "ArrowLeft":
                if (inputValue.value === "") {
                    setInputValue({
                        ...inputValue,
                        value: inputValue.clearValue,
                    });
                }
                while (cellIndex < totalCells) {
                    cellIndex = cellIndex + 1;
                    if (
                        document.getElementById(`${rowIndex}-${cellIndex}`) !==
                        null
                    ) {
                        document
                            .getElementById(`${rowIndex}-${cellIndex}`)
                            .focus();
                        break;
                    }
                }
                break;
            case "ArrowRight":
                if (inputValue.value === "") {
                    setInputValue({
                        ...inputValue,
                        value: inputValue.clearValue,
                    });
                }
                while (cellIndex > 0) {
                    cellIndex = cellIndex - 1;
                    if (
                        document.getElementById(`${rowIndex}-${cellIndex}`) !==
                        null
                    ) {
                        document
                            .getElementById(`${rowIndex}-${cellIndex}`)
                            .focus();
                        break;
                    }
                }
                break;
            default:
                if (
                    document.getElementById(`${rowIndex}-${cellIndex}`) !== null
                ) {
                    document.getElementById(`${rowIndex}-${cellIndex}`).focus();
                    break;
                }
                break;
        }
    };

    return (
        <div
            className={`
                editable-cell-container
                ${defaultFood.has_changed ? "has-changed" : ""}
            `}
        >
            <Form.Control
                className={`
                    editable-input noBorder
                    ${isDisabled ? "disable" : ""} 
                    ${
                        input.defaultValue !== inputValue?.value ? "edited" : ""
                    } ${!isUpdate ? "isBrown" : ""} 
                    ${
                        cellType === EXPAND_LIST_DAILY_TYPE.b2b
                            ? "editable-b2b"
                            : cellType === EXPAND_LIST_DAILY_TYPE.total
                            ? "editable-total"
                            : ""
                    }
                `}
                type="text"
                name={input.name}
                id={`${rowId}-${cellId}`}
                value={inputValue.value}
                disabled={isDisabled || cellType !== EXPAND_LIST_DAILY_TYPE.b2c}
                onChange={(event) =>
                    handleInputChange(
                        { hub_id: item.hub_id, product_id: item.product_id },
                        event.target.value
                    )
                }
                onKeyDown={(event) => {
                    if (event.key === "Escape") {
                        event.preventDefault();
                        event.stopPropagation();
                    } else {
                        changeCurrentCell(event.key, null, null);
                    }
                }}
                onFocus={() => changeCurrentCell("focus", rowId, cellId)}
                onBlur={() => changeCurrentCell("blur", rowId, cellId)}
            />

            <div className="b2b-stock d-none">
                <div className="mb-2">
                    <span>تعداد سهم غذای سازمانی:</span>
                    <span>{toPersianNum(item.b2b_stock, false)}</span>
                </div>
                <div>
                    <span>تعداد سهم غذای کیچن:</span>
                    <span>
                        {toPersianNum(item.qty - item.b2b_stock, false)}
                    </span>
                </div>
            </div>
        </div>
    );
};

EditableCell.propTypes = {
    item: PropTypes.object,
    handleLogChange: PropTypes.func,
    defaultFood: PropTypes.object,
    changedFlag: PropTypes.bool,
    isDisabled: PropTypes.bool,
    cellId: PropTypes.number,
    rowId: PropTypes.number,
    totalCells: PropTypes.number,
    totalRows: PropTypes.number,
    isUpdate: PropTypes.bool,
};

export default EditableCell;
